
import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import ConfirmDialog from '@/components/base/ConfirmDialog.vue';
import { SNACKBAR_STATUS } from '@/constants/constants';
import {
	CHECKOUT_ADD_FUNDS,
	CHECKOUT_ADD_FUNDS_TEAM,
} from '@run-diffusion/shared';
import { MyBalanceMixin, TeamUserMixin } from '@/mixins';
import { getDomainClaimRestrictionMessage } from '@/utils/domainClaimRestriction';

export default Vue.extend({
	name: 'AddBalanceFundsButton',
	mixins: [
		MyBalanceMixin,
		TeamUserMixin,
	],
	props: {
		type: {
			type: String,
			required: true,
			validator: (val: string) => ['personal', 'team'].includes(val),
		},
		btnProps: { type: Object, default: () => ({}) },
	},
	data () {
		return {
			balanceTooHighDialogOpen: false,
		};
	},
	computed: {
		...mapGetters([
			'displayLabels',
			'activeDomainClaimRestriction',
		]),
		...mapState([
			'authUser',
			'user',
		]),
		isPersonalBtn () {
			return this.type === 'personal';
		},
		isTeamBtn () {
			return this.type === 'team';
		},
		isBalanceTooHigh () {
			return !!(
				(this.isPersonalBtn && this.computedUserBalance > 10000) ||
				(this.isTeamBtn && this.computedTeamBalance > 200000)
			);
		},
	},
	methods: {
		...mapActions([
			'updateSnackbar',
			'updateLoader',
		]),
		checkBalanceTooHigh () {
			if (this.isBalanceTooHigh) {
				this.balanceTooHighDialogOpen = true;
			}
		},
		onBtnContainerClick () {
			this.$emit('click');
			if (this.isBalanceTooHigh) this.checkBalanceTooHigh();
		},
		async onAddFundsClick () {
			if (!this.type) {
				return;
			}
			this.checkBalanceTooHigh();
			await this.doAddFunds();
		},
		async doAddFunds () {
			if (this.balanceTooHighDialogOpen) return;
			if (this.activeDomainClaimRestriction) {
				this.updateSnackbar({
					status: SNACKBAR_STATUS.ERROR,
					message: getDomainClaimRestrictionMessage(this.activeDomainClaimRestriction, this.displayLabels.team),
					show: true,
				});
				return;
			}

			const routeData = this.$router.resolve({
				name: 'GoToPayment',
				query: {
					checkoutAction: this.isTeamBtn ? CHECKOUT_ADD_FUNDS_TEAM : CHECKOUT_ADD_FUNDS,
				},
			});
			window.open(routeData.href, '_blank');
			this.$emit('on-add-funds-click');
		},
	},
	components: {
		ConfirmDialog,
	},
});
